export default function (a, b) {
  return a = +a, b -= a, function (t) {
    return a + b * t;
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-interpolate@1.1.6@d3-interpolate/src/number.js
// module id = 43
// module chunks = 0 1 2